import ModalShell from '../ModalShell';
import './RecruitmentChallengeModal.css';

// Layout for the "Recruitment Challenge" project: video-first, no hero image.
// This layout is independent from ArtGalleryModal and can evolve freely.
function RecruitmentChallengeModal({ project, onClose }) {
  return (
    <ModalShell titleId="recruitment-challenge-modal-title" onClose={onClose}>
      <div className="recruitment-challenge-modal">
        <div className="recruitment-challenge-modal__body">
          <p className="eyebrow">Recruitment challenge</p>
          <h2 id="recruitment-challenge-modal-title">{project.title}</h2>
          {project.tools.length > 0 && (
            <ul className="recruitment-challenge-modal__tools">
              {project.tools.map((tool) => <li key={tool}>{tool}</li>)}
            </ul>
          )}
          {Array.isArray(project.modalDescription)
            ? project.modalDescription.map((paragraph) => <p key={paragraph}>{paragraph}</p>)
            : project.modalDescription && <p>{project.modalDescription}</p>}
        </div>
        <div className="recruitment-challenge-modal__video-wrapper">
          <iframe
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className="recruitment-challenge-modal__video"
            src="https://www.youtube.com/embed/O-FKRIqSe_M"
            title="Recruitment Challenge gameplay"
          />
        </div>
      </div>
    </ModalShell>
  );
}

export default RecruitmentChallengeModal;
